const DEFAULTS = Object.freeze({});
export {
  DEFAULTS
};
//# sourceMappingURL=defaults.js.map
